// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemTemplateImportModalQueryVariables = Types.Exact<{
  itemTemplateId: Types.Scalars['ID']['input'];
  locationFilter?: Types.InputMaybe<Types.LocationsFilter>;
  itemFilter?: Types.InputMaybe<Types.ItemFilter>;
}>;


export type ItemTemplateImportModalQuery = { __typename?: 'Query', costTypes: Array<{ __typename?: 'CostTypeDetail', code: Types.CostType, name: string }>, unitsOfMeasure: Array<{ __typename?: 'UnitOfMeasure', id: string, name: string, useQuantity: boolean }>, locations: Array<{ __typename?: 'Location', id: string, name: string, isWholeHouse: boolean, path?: string | null | undefined, version: number }>, items: Array<{ __typename?: 'Item', id: string, fullCode: string, version: number }>, itemTemplate: { __typename?: 'ItemTemplate', id: string, readyPlan?: { __typename?: 'ReadyPlan', id: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string }> } | null | undefined } };


export const ItemTemplateImportModalDocument = gql`
    query ItemTemplateImportModal($itemTemplateId: ID!, $locationFilter: LocationsFilter, $itemFilter: ItemFilter) {
  costTypes {
    code
    name
  }
  unitsOfMeasure {
    id
    name
    useQuantity
  }
  locations(filter: $locationFilter) {
    id
    name
    isWholeHouse
    path
    version
  }
  items(filter: $itemFilter) {
    id
    fullCode
    version
  }
  itemTemplate(id: $itemTemplateId) {
    id
    readyPlan {
      id
      options {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useItemTemplateImportModalQuery__
 *
 * To run a query within a React component, call `useItemTemplateImportModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplateImportModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplateImportModalQuery({
 *   variables: {
 *      itemTemplateId: // value for 'itemTemplateId'
 *      locationFilter: // value for 'locationFilter'
 *      itemFilter: // value for 'itemFilter'
 *   },
 * });
 */
export function useItemTemplateImportModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables> & ({ variables: ItemTemplateImportModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables>(ItemTemplateImportModalDocument, options);
      }
export function useItemTemplateImportModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables>(ItemTemplateImportModalDocument, options);
        }
// @ts-ignore
export function useItemTemplateImportModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables>;
export function useItemTemplateImportModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplateImportModalQuery | undefined, ItemTemplateImportModalQueryVariables>;
export function useItemTemplateImportModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables>(ItemTemplateImportModalDocument, options);
        }
export type ItemTemplateImportModalQueryHookResult = ReturnType<typeof useItemTemplateImportModalQuery>;
export type ItemTemplateImportModalLazyQueryHookResult = ReturnType<typeof useItemTemplateImportModalLazyQuery>;
export type ItemTemplateImportModalSuspenseQueryHookResult = ReturnType<typeof useItemTemplateImportModalSuspenseQuery>;
export type ItemTemplateImportModalQueryResult = ApolloReactCommon.QueryResult<ItemTemplateImportModalQuery, ItemTemplateImportModalQueryVariables>;